import { create } from "zustand";

type Student = {
    id : number
    name : string | null
    birthday ?: string | null
    email ?: string | null
    is_active ?: boolean | null
    payment_status ?: string | null
    profile_pic ?: string | null
    student_standard ?: string | null
}

interface CourseStore {
    courses: []
    setCourses: (data: []) => void
    students: null | Student[]
    setStudents: (data: Student[]) => void
    selectedStudent: null | Student
    setSelectedStudent: (data: Student) => void
    lastVisitedCourseId: string | null
    setLastVisitedCourseId: (path: string) => void
    clearLastVisitedCourse: () => void
}

export const useCourseStore = create<CourseStore>((set) => ({
    courses: [],
    setCourses: (data) => set({ courses: data }),
    students: [],
    setStudents: (data: Student[]) => set({ students: data }),
    selectedStudent: null,
    setSelectedStudent: (data: Student) => set({ selectedStudent: data }),
    lastVisitedCourseId: null,
    setLastVisitedCourseId: (path) => set({ lastVisitedCourseId: path }),
    clearLastVisitedCourse: () => set({ lastVisitedCourseId: null }),
}))